// Vue Scrollmagic (https://github.com/magr0s/vue-scrollmagic)
import Vue from 'vue'
import VueScrollmagic from 'vue-scrollmagic'

Vue.use(VueScrollmagic)
